import type { RectangleLayerData } from './components/Layer.types';
export const TEMPLATE_PLACEHOLDER_LINK = 'withjoy.com/name-and-name';
export const HANDWRITING_GUIDE_LINE_LAYER_NAME = 'handwritingGuideLine';
// Postcard back templates tag their return-address layer with this so joy-web can find it (modal edit + structured render).
export const RETURN_ADDRESS_LAYER_NAME = 'returnAddress';

/**
 * Handwriting guide lines for the postcard back's address block.
 *
 * Templates author these as named `handwritingGuideLine` rectangles, but every consumer either
 * strips them (printed addressing) or wants them verbatim (Leave Blank), so joy-web owns them
 * instead: `stripHandwritingGuideLines` drops the authored copies at the edge, and
 * `withHandwritingGuideLines` injects these on the paths that render them. Keep the geometry in
 * sync with stationery-templates.
 *
 * Reviewer FAQ — three things that look like defects and are not:
 *
 * - **The coordinates are landscape-only.** There are no portrait postcard backs, and none are
 *   planned. If that ever changes, key the geometry off orientation rather than patching these
 *   numbers.
 * - **No `name` on these layers.** Deliberate. The goal is to retire
 *   `HANDWRITING_GUIDE_LINE_LAYER_NAME` entirely once templates stop authoring the lines; it
 *   survives only so `stripHandwritingGuideLines` can recognize the template-authored copies.
 *   Tagging joy-web's own layers with it would re-create the coupling this change removes.
 * - **It is a factory, not a constant array.** Each call must return fresh objects: the layers are
 *   appended into a draft that is handed to an Apollo mutation, and Apollo deep-freezes mutation
 *   variables in dev — sharing one module-level array would freeze it for the rest of the session.
 */
export const getPostcardAddressGuideLineLayers = (): Array<RectangleLayerData> =>
  [144, 170, 196, 222].map(y => ({
    type: 'rectangle',
    editable: false,
    layout: { x: 237, y, width: 177, height: 0.75 },
    rectangleData: { fill: 'rgb(119,119,119)' },
  }));
